module.exports = "<style>#hierarchyrefer td{cursor:pointer}</style> <div id=hierarchyrefer> <div class=u-row style=min-height:464px> <u-grid params=config:config></u-grid> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/modalrefer/hierarchy/mainGrid/index.html
// module id = 293
// module chunks = 144